import { useSyncExternalStore } from 'react';

const subscribe = () => () => {};

/**
 * false — в пререндере и во время гидратации, true — сразу после неё.
 * Для разметки, которая зависит от браузера (тема из localStorage): гидратация видит серверный
 * вариант и не расходится с HTML, затем React сам перерисовывает в настоящий
 */
export const useHydrated = (): boolean =>
  useSyncExternalStore(
    subscribe,
    () => true,
    () => false,
  );
